import {
  createContext,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
  type PropsWithChildren,
} from "react";

interface LayoutChromeContextValue {
  chromeHidden: boolean;
  setChromeHidden: (hidden: boolean) => void;
}

const LayoutChromeContext = createContext<LayoutChromeContextValue>({
  chromeHidden: false,
  setChromeHidden: () => undefined,
});

export const LayoutChromeProvider = ({ children }: PropsWithChildren) => {
  const [chromeHidden, setChromeHidden] = useState(false);
  const value = useMemo(
    () => ({ chromeHidden, setChromeHidden }),
    [chromeHidden]
  );

  return (
    <LayoutChromeContext.Provider value={value}>
      {children}
    </LayoutChromeContext.Provider>
  );
};

export const useLayoutChrome = () => useContext(LayoutChromeContext);

/** Renders the calling page without the header, sidebars, and chat. */
export const useHideLayoutChrome = () => {
  const { setChromeHidden } = useLayoutChrome();

  useLayoutEffect(() => {
    setChromeHidden(true);
    return () => setChromeHidden(false);
  }, [setChromeHidden]);
};
